import React from 'react';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Shimmer } from '../../../CommonComponents/OPL/Shimmer/Shimmer';

export const UserActivityItemLoading = () => {
  return (
    <>
      <Shimmer width={40} height={40} isRound />
      <Box display="flex" flexDirection="column" flex={1} ml="8" width="90%">
        <Shimmer width="75%" height="20px" />
      </Box>
      <Shimmer width="56px" height="20px" />
    </>
  );
};
